
export const settings = {

	company: {
		name: "Guardia Corporate",
	},

	country: {
		default: "Australia",
	}

};